/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListTradingChallengesOptions,
  ListTradingChallengesResponses,
} from '../types/ListTradingChallenges'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description List trading challenges. COMPETITION_MANAGER callers only receive challenges present in their managed_competition_ids.
 * @summary List trading challenges
 * {@link /v1/trading_challenges}
 */
export function listTradingChallenges<ThrowOnError extends boolean = true>(
  options: Options<ListTradingChallengesOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListTradingChallengesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading_challenges',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListTradingChallengesResponses, ThrowOnError>>,
  )
}
